import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-inline-flex" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.isAdmin)
    ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "plain",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-arrow-left")
                ])),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" Back "))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "mx-auto mt-4 py-2 px-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h5" }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Access Requests ")
                ])),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.hideSent,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hideSent) = $event)),
                  label: "Hide Sent Today",
                  class: "d-inline-flex"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.allowResend,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.allowResend) = $event)),
                  label: "Allow Resend",
                  class: "ml-4 d-inline-flex"
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_1, [
                  _createVNode(_component_v_select, {
                    label: "Template",
                    items: _ctx.emailTemplateNames,
                    modelValue: _ctx.selectedTemplateToSend,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTemplateToSend) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    class: "ml-4 email-select"
                  }, null, 8, ["items", "modelValue"])
                ]),
                _createVNode(_component_v_btn, {
                  class: "ml-4 mt-n8 d-inline-flex",
                  onClick: _ctx.sendEmailToAll,
                  disabled: _ctx.sendingToAll
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("Send reminder to all")
                  ])),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              (_ctx.sendingToAll)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("span", null, "Sending reminder to " + _toDisplayString(_ctx.sendingToAllCount) + " people.", 1),
                    _createVNode(_component_v_progress_linear, {
                      modelValue: _ctx.sendingToAllCount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sendingToAllCount) = $event)),
                      class: "ml-4 d-inline-flex",
                      height: "10",
                      color: "primary",
                      max: _ctx.accessRequestsList.length
                    }, null, 8, ["modelValue", "max"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_data_table, {
                headers: _ctx.requestTableHeaders,
                items: _ctx.accessRequestsList,
                loading: _ctx.requestsLoading
              }, {
                [`item.timestamp`]: _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(item.timestamp)), 1)
                ]),
                [`item.actions`]: _withCtx(({ item }) => [
                  (item.emailSentAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_icon, { color: "green" }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("mdi-check")
                          ])),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(item.emailSentAt)) + " ", 1),
                        (_ctx.allowResend)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              color: "primary",
                              size: "small",
                              class: "mr-2",
                              onClick: ($event: any) => (_ctx.sendEmail(item, _ctx.selectedTemplateToSend, true))
                            }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode(" Resend ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        color: "primary",
                        size: "small",
                        class: "mr-2",
                        onClick: ($event: any) => (_ctx.sendEmail(item, _ctx.selectedTemplateToSend, true))
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode(" Send Welcome Email ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                _: 2
              }, 1032, ["headers", "items", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, { onClick: _ctx.createNewTemplate }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("Create New Template")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTemplatesList, ({ name, template }) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: `${name}-${Date.now()}`,
                          title: name,
                          onClick: ($event: any) => {_ctx.selectedTemplate = template; _ctx.selectedTemplateName = name}
                        }, null, 8, ["title", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "mx-auto mt-0 py-2 px-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5" }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode(" Edit Template ")
                        ])),
                        _: 1
                      }),
                      (_ctx.selectedTemplate != null)
                        ? (_openBlock(), _createBlock(_component_v_form, {
                            key: 0,
                            onSubmit: _withModifiers(_ctx.saveTemplate, ["prevent"]),
                            ref: "form"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.selectedTemplateName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTemplateName) = $event)),
                                label: "Template Name",
                                required: "",
                                rules: [v => !!v || 'Name is required']
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.selectedTemplate.from,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTemplate.from) = $event)),
                                label: "From",
                                required: "",
                                rules: [v => !!v || 'From address is required']
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.selectedTemplate.subject,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTemplate.subject) = $event)),
                                label: "Email Subject",
                                required: "",
                                rules: [v => !!v || 'Subject is required']
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.selectedTemplate.html,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedTemplate.html) = $event)),
                                label: "HTML Content",
                                required: "",
                                rules: [v => !!v || 'HTML is required'],
                                rows: "10"
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.selectedTemplate.text,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTemplate.text) = $event)),
                                label: "Text Content",
                                required: "",
                                rules: [v => !!v || 'Text is required'],
                                rows: "10"
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, { onClick: _ctx.saveTemplate }, {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createTextVNode("Save")
                                    ])),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onSubmit"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}